import { render, staticRenderFns } from "./CompanyModuleAccess.vue?vue&type=template&id=9026f518&scoped=true"
import script from "./CompanyModuleAccess.vue?vue&type=script&lang=js"
export * from "./CompanyModuleAccess.vue?vue&type=script&lang=js"
import style0 from "./CompanyModuleAccess.vue?vue&type=style&index=0&id=9026f518&prod&scoped=true&lang=css"
import style1 from "./CompanyModuleAccess.vue?vue&type=style&index=1&id=9026f518&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9026f518",
  null
  
)

export default component.exports